<template>
	<van-row class="">
		<Header></Header>
		<van-row class="Coursedetail w95">
			<van-row class='cobg'>
				<img >
			</van-row>
			<van-row class='coname'>
				<p>2019年（下）国考教师资格证-考前押题刷题（幼儿）</p>
			</van-row>
			<van-row class='contxt'>
				<p>已有<span style="color: #FF5590;">422</span>人购买</p>
				<p>¥ 280</p>
			</van-row>
			<van-row class='coline'></van-row>
			<van-row class='cobtn'>
				<p>开课中</p>
				<p @click="buy()"><span>立即购买</span></p>
			</van-row>
		</van-row>
		<van-row class='colist w95'>
			<div class="nav">
				<van-tabs  title-inactive-color='#666' title-active-color='#007CCF' background="#fafafa"
				 swipeable animated :ellipsis="false" >
					<van-tab title="课程详情" name='0'>
						<van-row style="margin-top: 10px;" class="list1">
							<p>
								看似简单会计考试的还是考虑去沃尔看见了雷克萨多了；打卡；立即打死了；的；拉到了；
								 看似简单会计考试的还是考虑去沃尔看见了雷克萨多了；打卡；立即打死了；的；拉到了； 
								 看似简单会计考试的还是考虑去沃尔看见了雷克萨多了；打卡；立即打死了；的；拉到了； 
							</p>
							<img src="../assets/home/bg4.png" alt="">
						</van-row>
					</van-tab>
					<van-tab title="课程表" name='1'>
						<van-row style="margin-top: 10px;" class="list1">
							
							<van-row class='colcourselist'  type='flex' v-for='(item,index) in 5' :key='index'>
								<van-col class='col1'>
									<p>{{index+1}}</p>
								</van-col>
								<van-col class='col2'>
									<p>教师的文化素养（1）</p>
									<p>2018.06.06 &nbsp; &nbsp; 2018.06.06</p>
								</van-col>
								
							</van-row>
								
						</van-row>
					</van-tab>
					<van-tab title="老师简介" name='2'>
						<van-row v-for='(item,index) in 5' :key='index'>
							 <van-row type='flex' class='tecol' >
							 	<p>
									<img src="../assets/home/bg4.png" alt="">
								</p>
								<p>
									<span>某某某</span>
									<span>云师著名什么什么老师</span>
								</p>
							 </van-row>
							 <van-row>
								<p style="margin: 13px;color: #999;font-size: 14px;">
									思想家、政治学家、哲学家、经济学家、革命理论家、社会学家
									生卒：1818年5月5日-1883年3月14日
									代表作品：《资本论》《共产党宣言》《关于费尔巴哈的提...
									简介：卡尔·马克思，全名卡尔·海因里希·马克思（德语：Karl
								</p>
							 </van-row>
						</van-row>
					</van-tab>
					<van-tab title="报名须知" name='3'>
						<van-row style="margin-top: 10px;" class="list1">
							<p>
								看似asdsadasd尔看见了雷克萨多了；打卡；立即打死了；的；拉到了； 
								 看似简单会计考试的还是考虑去沃尔看见了雷克萨多了；打卡；立即打死了；的；拉到了； 
							</p>
							<!-- <img src="https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=133538229,23473127&fm=26&gp=0.jpg" alt=""> -->
						</van-row>
					</van-tab>
				
				</van-tabs>
			</div>
		</van-row>
		<Fotter></Fotter>
	</van-row>
</template>

<script>
	import Vue from 'vue'
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	import { Dialog } from 'vant';
	// 全局注册
	Vue.use(Dialog);
	export default {
		name: 'Coursedetail',
		components: {
			Header,
			Fotter,
		
		},
		data() {
			return {

			}

		},
		methods: {
        buy(){
			Dialog.confirm({
			  title: '温馨提示',
			  showCancelButton:false,
			  message: '请前往APP进行购买'
			}).then(() => {
			  // on confirm
			}).catch(() => {
			  // on cancel
			});
		}
		}
	}
</script>

<style scoped>
	.Coursedetail {
		margin: 20px auto;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 4px 10px rgba(0, 124, 216, 0.1);
	}

	.cobg {
		width: 100%;
		height: 192px;
	}

	.cobg img {
		width: 100%;
		height: 100%;
	}

	.coname p {
		margin: 13px 13px 0px 13px;
		font-size: 15px;
		font-weight: 600;
		line-height: 23px;
		color: rgba(51, 51, 51, 1);
	}

	.contxt {
		height: 40px;
		line-height: 30px;
		font-size: 14px;
	}

	.contxt p {
		display: inline-block;
		margin: 13px;
	}

	.contxt p:nth-child(1) {
		float: left;
	}

	.contxt p:nth-child(2) {
		float: right;
		color: #FF5590;
	}

	.coline {
		width: 95%;
		height: 0px;
		border: 1px solid rgba(204, 204, 204, 1);
		margin: 20px auto;
	}

	.cobtn {
		width: 100%;
		height: 50px;

		margin: 0px auto 20px auto;
		display: flex;

	}

	.cobtn p:nth-child(1) {
		flex: 1;
		margin: 13px;
		font-weight: 300;
		color: rgba(153, 153, 153, 1);
	}

	.cobtn p:nth-child(2) {
		width: 94px;
		margin-top: 13px;
	}

	.cobtn p:nth-child(2) span {
		background: rgba(0, 124, 207, 1);
		border-radius: 22px;
		padding: 9px 11px;
		color: #fff;
		line-height: 20px;
		font-weight: bold;
	}
	.colist{
		margin: 30px auto;
		background:rgba(255,255,255,1);
		box-shadow:0px 4px 10px rgba(0,124,216,0.1);
		border-radius:7px;

	}
	.list1 p{
		margin: 13px;
		line-height: 20px;
		color: #666;
		font-size: 14px;
	}
		.list1 img{
			width: 100%;
		}
		.colcourselist{
			width: 95%;
			height: 100px;
		
		}
		.col1{
			width: 60px;
		
		}
		.col1 p{
			width: 25px;
			height: 25px;
			background: #007CCF;
			border-radius: 100%;
			text-align: center;
			line-height: 25px;
			color: #fff;
		}
		.col2{
			flex: 1;
			
		}
		.col2 P:nth-child(1){
			color: #007CCF;
		}
		.tecol{
		
		}
		.tecol p:nth-child(1){
			width:100px;
			height: 83px;
			margin: 13px;
		}
		.tecol p:nth-child(1) img{
			width: 100%;
			height: 100%;
		}
		.tecol p:nth-child(2){
			flex: 1;
		
		}
		.tecol p:nth-child(2) span{
			display: block;
			margin: 13px;
		}
		.tecol p:nth-child(2) span:nth-child(1){
			font-size: 14px;
			color: #333;
			font-weight: bold;
		}
		.tecol p:nth-child(2) span:nth-child(2){
			color: #999;
		}
</style>



// WEBPACK FOOTER //
// src/components/Coursedetail.vue